// The strings this screen hands to the dynamic-form module, which ships no i18n of
// its own.

import { t } from '@lingui/macro';

const dynamicFormTexts = () => ({
  cantBeBlank: t`Can't be blank`,
  invalidEmail: t`Invalid email`,
  invalidFormat: (error) => t`Invalid format ${error}`,
  invalidExtension: t`Invalid extension (Allowed: xml, pdf or json)`,
  extensionMismatch: (ext) => t`Invalid extension: ${ext}. Check File Type.`,
  jsonEditor: t`JSON Editor`,
  encrypted: t`Encrypted`,
  headerKey: t`key`,
  headerValue: t`value`,
  add: t`Add`,
  removeEntry: t`Remove entry`,
});

export default dynamicFormTexts;
